import React from "react";
import { Link } from "react-router-dom";
export default function Disclaimer() {
  return (
    <>
      <p>
        The information provided on the Dox and Box website and platform is for general informational and business purposes only. While we strive to ensure accuracy and reliability, we make no guarantees regarding the completeness, accuracy, or suitability of the information for any specific purpose.
      </p>

      <h3 className="heading">No Professional Advice</h3>
      <p>
        The content, services, solutions offered by Dox and Box do not constitute legal, financial, or professional advice. Users are advised to seek appropriate professional consultation before making decisions based on information or outputs derived from our platform.
      </p>

      <h3 className="heading">Service Availability & Performance</h3>
      <p>
        Dox and Box aims to provide reliable and uninterrupted services. However, we do not guarantee that the platform will always be available, error-free, or free from delays. Temporary interruptions may occur due to maintenance, upgrades, or unforeseen technical issues.
      </p>

      <h3 className="heading">Limitation of Liability</h3>
      <p>
        To the fullest extent permitted by applicable law, Dox and Box shall not be held liable for any direct, indirect, incidental, or consequential damages arising from: Use or inability to use the platform, Loss of data, revenue, or business opportunities, Unauthorized access or system failures beyond our control.
      </p>

      <h3 className="heading">Data & Document Responsibility</h3>
      <p>
        Users are solely responsible for the accuracy, legality, integrity of the data and documents uploaded to the platform. Dox and Box does not verify or validate the content of user-uploaded materials and shall not be held responsible for any misuse or legal implications arising from such content.
      </p>

      <h3 className="heading">Third-Party Links & Integrations</h3>
      <p>
        The platform may include links or integrations with third-party websites and services. Dox and Box does not control or endorse these external platforms and is not responsible for their content, security, or privacy practices. Use of third-party services is at the user’s own risk.
      </p>

      <h3 className="heading">Security Disclaimer</h3>
      <p>
        While Dox and Box implements industry-standard security measures to protect data, no system can be completely secure. Users acknowledge that there are inherent risks in transmitting and storing data electronically and agree to use the platform at their own discretion.
      </p>

      <h3 className="heading">No Warranties</h3>
      <p>
        All services and content are provided on an “as-is” and “as-available” basis. Dox and Box disclaims all warranties, express or implied, including but not limited to merchantability, fitness for a particular purpose, non-infringement.
      </p>

      <h3 className="heading">Changes to Disclaimer</h3>
      <p>
        Dox and Box reserves the right to update or modify this Disclaimer at any time without prior notice. Continued use of the website and services constitutes acceptance of any changes.
      </p>

      <h3 className="heading">Contact Us</h3>
      <p>For any questions regarding this Disclaimer, please contact:
      </p>
      <p>Email: <Link to={"mailto:info@doxandbox.com"}>info@doxandbox.com</Link>
        <br />
        Phone: <Link to={"tel:+91-9580374374"}>+91-9580374374</Link></p>

    </>
  );
}
